<template>
  <Loading :show="isLoading" @hidden="onLoadingHidden" />
  <HeaderComponent />
  <div class="body-container">
    <transition name="page-fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import HeaderComponent from './components/Header.vue'
import Loading from './components/Loading.vue'

export default {
  name: 'App',
  components: { HeaderComponent, Loading },
  data() {
    return {
      isLoading: true,
      minShowMs: 600, // tempo minimo per vedere il loader
      navStart: 0
    }
  },
  created() {
  this.$router.beforeEach((to, from, next) => {
    this.navStart = Date.now()
    this.isLoading = true
    // ritardo artificiale di 600ms per test
    setTimeout(() => next(), 400)
  })

  this.$router.afterEach(() => {
    const elapsed = Date.now() - this.navStart
    const remain = Math.max(0, this.minShowMs - elapsed)
    setTimeout(() => { this.isLoading = false }, remain)
  })
  },
  methods: {
    onLoadingHidden() {
      // opzionale: quando overlay ha finito il leave (è sparito)
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Fascinate&family=Updock&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Special+Elite&display=swap');


* {
  margin: 0;
  font-family: 'Special Elite', cursive;
  padding: 0;
  box-sizing: border-box;
}

/* prevent horizontal scroll caused by vw usage or background sizing */
html, body { 
  margin: 0;
  padding: 0;
  width: 100%;
  overflow-x: hidden; 
}

.body-container{
  width: 100%;
}

html {
  scroll-behavior: smooth;
}

.page-fade-enter-from { opacity: 0; transform: translateY(6px); }
.page-fade-enter-to { opacity: 1; transform: translateY(0); }
.page-fade-enter-active { transition: opacity 300ms ease, transform 300ms ease; }

.page-fade-leave-from { opacity: 1; transform: translateY(0); }
.page-fade-leave-to { opacity: 0; transform: translateY(-6px); }
.page-fade-leave-active { transition: opacity 250ms ease, transform 250ms ease; }

</style>